import classnames from 'classnames';
import { numberFormat } from 'lib/utils';
import React from 'react';
import styles from './styles.scss';

interface Props {
  className?: string;
  amount: number;
}

const DisposableIncome = ({ className, amount }: Props): JSX.Element => {
  if (!amount) return null;
  return (
    <section className={classnames(styles.container, amount < 0 && styles.negative, className && className)}>
      <span className={styles.label}>Tilgjengelig inntekt</span>
      <span className={styles.amount}>{numberFormat.format(amount)},-</span>
    </section>
  );
};

export default DisposableIncome;
